export default "__VITE_ASSET__BaqNLWMk__"